
import { Route, Routes } from 'react-router';
import './App.css';
import Footer from './Components/Common/Footer';
import NavBar from './Components/Common/NavBar';
import AboutUs from './Pages/AboutUs';
import Home from './Pages/Home';
import Products from './Pages/Products'
import ContectUs from './Pages/ContectUs'

function App() {
  return (
    <div className="App">
      <NavBar/>
      <Routes>
        <Route path='/' element={<Home/>}/>
        <Route path='/AboutUs' element={<AboutUs/>}/>
        <Route path='/Products' element={<Products/>}/>
        <Route path='/ContectUs' element={<ContectUs/>}/>
      </Routes>
      <Footer/>
    </div>
  );
}

export default App;
